import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import './TauriCustomPaganation.css';
import TauriImage from '../TauriImage/TauriImage';

const TauriCustomPaganation = ({ currentPage, totalPages, onPageChange, displayPerPage, onDisplayPerPage, totalItems }) => {
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
        }
    };

    const handleDisplayPerPageChange = (value) => {
        onDisplayPerPage(value);
    };

    const getPageRange = () => {
        const range = 1;
        let start = Math.max(1, currentPage - range);
        let end = Math.min(totalPages, currentPage + range);

        // Adjust the range if it's close to the start or end
        if (currentPage - range < 1) {
            end = Math.min(totalPages, end + (range - (currentPage - 1)));
        }
        if (currentPage + range > totalPages) {
            start = Math.max(1, start - (currentPage + range - totalPages));
        }

        return { start, end };
    };

    const { start, end } = getPageRange();

    return (
        <div className="tauri-custom-pagination">
            <div className="pagination-totalItems">
                Total Items: {totalItems}
            </div>

            <Dropdown className="pagination-dropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Show | {displayPerPage}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {[10, 20, 50, 100].map(value => (
                        <Dropdown.Item key={value} onClick={() => handleDisplayPerPageChange(value)}>
                            {value}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            <button
                className="pagination-button first"
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                aria-label="First Page"
            >
                <TauriImage localImage={'/Images/firstpage.svg'} className={'pagination-icon first-page'} alt='Icon'/>
            </button>
            <button
                className="pagination-button prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                aria-label="Previous Page"
            >
                <TauriImage localImage={'/Images/prevpage.svg'} className={'pagination-icon prev-page'} alt='Icon'/>
            </button>
            {[...Array(end - start + 1)].map((_, i) => (
                <button
                    key={start + i}
                    className={`pagination-button ${start + i === currentPage ? 'active' : ''}`}
                    onClick={() => handlePageChange(start + i)}
                    aria-label={`Page ${start + i}`}
                >
                    {start + i}
                </button>
            ))}
            <button
                className="pagination-button next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                aria-label="Next Page"
            >
                <TauriImage localImage={'/Images/nextpage.svg'} className={'pagination-icon next-page'} alt='Icon'/>
            </button>
            <button
                className="pagination-button last"
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                aria-label="Last Page"
            >
                <TauriImage localImage={'/Images/lastpage.svg'} className={'pagination-icon last-page'} alt='Icon'/>
            </button>
        </div>
    );
};

export default TauriCustomPaganation;
